module.exports = __webpack_public_path__ + "img/framenew_box20.04e5ba69.jpg";